import React from 'react';

function PlusMinusIcon({option}) {
  return (option === 'plus'
    ? (
      <svg version="1.1" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 15 15" enableBackground="new 0 0 15 15">
        <path fill="#9D9D9C" d="M12.83,6.61H8.39V2.17c0-0.49-0.4-0.89-0.89-0.89s-0.89,0.4-0.89,0.89v4.44H2.17 c-0.49,0-0.89,0.4-0.89,0.89s0.4,0.89,0.89,0.89h4.44v4.44c0,0.49,0.4,0.89,0.89,0.89s0.89-0.4,0.89-0.89V8.39h4.44 c0.49,0,0.89-0.4,0.89-0.89S13.32,6.61,12.83,6.61L12.83,6.61z"/>
      </svg>
    ) : (
      <svg version="1.1" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 15 15" enableBackground="new 0 0 15 15">
        <path fill="#9D9D9C" d="M12.83,6.61H2.17c-0.49,0-0.89,0.4-0.89,0.89s0.4,0.89,0.89,0.89h4.44h6.22 c0.49,0,0.89-0.4,0.89-0.89S13.32,6.61,12.83,6.61L12.83,6.61z"/>
      </svg>
    )
  );
}

export default PlusMinusIcon;



// WEBPACK FOOTER //
// ./src/components/icons/PlusMinusIcon.js